<div id="page-title">
    <div id="page-content" class="inicio" id="transacoes">
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="row">
            <div class="container-datepicker col-xs-12">
              <app-datepicker (filter)="setFilterData($event)"></app-datepicker>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div id="input-tag" class="input textarea caixa-pesquisa">
                <div>
                  <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!loaded && !error" class="container-loading">
            <div class="btn btn-registrar loading"></div>
          </div>
          <div class="col-md-10 col-md-offset-1" *ngIf="error">
            <span class="error">Nenhuma informação disponível no momento</span>
            <span class="error">Tente novamente mais tarde</span>
          </div>

          <table id="master-detail-table-proximas-transacoes" style="width: 100%"></table>
        </div>
      </div>
    </div>
</div>

<app-modal-detail></app-modal-detail>
